/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_Managed_RolesInputs */



/**
* | output |
* | --- |
* | "Roles Colossus creates or takes over and keeps in sync" |
*
* @param {Pricing_Compare_Leveling_Managed_RolesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_managed_roles = /** @type {((inputs?: Pricing_Compare_Leveling_Managed_RolesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_Managed_RolesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Роли, которые Colossus создаёт или берёт под управление и держит в актуальном виде")
	return /** @type {LocalizedString} */ ("Roles Colossus creates or takes over and keeps in sync")
});